import { PageStoreType } from '@/types/storeTypes/pageStoreTypes'
import { StateCreatorType } from '@/types/storeTypes/storeType'

const pageStore: StateCreatorType<PageStoreType> = (set) => ({
  page: null,
  loading: false,
  setLoading: (isLoading) =>
    set((state) => void (state.page.loading = isLoading), false, 'setLoading'),
  setPage: (page) =>
    set(
      (state) => {
        state.page.page = page
      },
      false,
      'setPage',
    ),
  setPageFocusId: (focusId) =>
    set(
      (state) => {
        if (state.page.page) {
          state.page.page.focusId = focusId
        }
      },
      false,
      'setPageFocusId',
    ),
  setPageAnchorId: (anchorId) =>
    set(
      (state) => {
        if (state.page.page) {
          state.page.page.anchorId = anchorId
        }
      },
      false,
      'setPageAnchorId',
    ),
  setTabIndex: (index: number) =>
    set(
      (state) => {
        if (state.page.page) {
          state.page.page.tabIndex = index
        }
      },
      false,
      'setTabIndex',
    ),
  setSlideIndex: (index: number) =>
    set(
      (state) => {
        if (state.page.page) {
          state.page.page.slideIndex = index
        }
      },
      false,
      'setSlideIndex',
    ),
})

export default pageStore
